// extracted by mini-css-extract-plugin
module.exports = {"castCrewComponentWrapper":"hi","castCrewHeader":"hj","castCrewBody":"hk","castCrewTitle":"hl","slipnslideArrow":"hm"};